import gql from 'graphql-tag'
import { standardOrder } from '../fragments'

const updateStandardOrderMutation = gql`
mutation CA_Mutation_updateStandardOrderValues($id: ID!, $fields: StandardOrderValuesInput) {
	cashAssist {
		updateStandardOrderValues(id: $id, fields: $fields) {
			...standardOrder
		}
	}
}
${standardOrder}`

export default updateStandardOrderMutation
